<template>
  <el-card class="status-page">
    <div slot="header" class="header">
      <span
        >ServerStatus
        <small
          ><a :href="statusSrc" target="_blank">by freshping.io</a></small
        ></span
      >
      <el-button type="text" @click="refresh">Refresh</el-button>
    </div>
    <div v-if="statusSrc">
      <vue-friendly-iframe
        class="iframe-container"
        :src="statusSrc"
        frameborder="0"
        allowfullscreen="allowfullscreen"
      ></vue-friendly-iframe>
    </div>
  </el-card>
</template>

<style scoped>
.status-page {
  margin: 0 20px;
}

.iframe-container {
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;
}

.iframe-container >>> iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

<script>
import VueFriendlyIframe from 'vue-friendly-iframe'

const statusSrc = 'https://statuspage.freshping.io/7106-ServerStatus'

export default {
  components: {
    VueFriendlyIframe
  },

  data () {
    return {
      statusSrc: statusSrc
    }
  },

  methods: {
    refresh () {
      this.statusSrc = ''
      setTimeout(() => {
        this.statusSrc = statusSrc
      }, 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/StatusPage.vue